<button
    mat-icon-button
    [matMenuTriggerFor]="pendingMenu"
    [matTooltip]="'Entradas sem turno aguardando aprovação' | autoTranslate"
>
    <mat-icon
        class="icon-size-5"
        [matBadge]="requests.length"
        [matBadgeHidden]="!requests.length"
        matBadgeColor="warn"
        matBadgeSize="small"
        [svgIcon]="'heroicons_outline:clock'"
    ></mat-icon>
</button>

<mat-menu #pendingMenu="matMenu" xPosition="before" class="access-approval-bell-menu">
    <div class="px-4 py-2 w-72" (click)="$event.stopPropagation()">
        <div class="font-semibold" autoTranslate>Entrada sem turno</div>

        <div class="mt-2 text-sm text-secondary text-center py-4" *ngIf="!requests.length" autoTranslate>
            Nenhum pedido pendente.
        </div>

        <div class="mt-2 flex flex-col gap-3" *ngFor="let request of requests">
            <div class="flex flex-col gap-1 border-b pb-3 last:border-b-0 last:pb-0">
                <div class="font-medium">{{ request.user_name }}</div>
                <div class="text-xs text-secondary" autoTranslate>
                    Solicitado em {{ request.createdAt | date : 'dd/MM/yyyy HH:mm' }}
                </div>
                <div class="flex gap-2 mt-1">
                    <button mat-stroked-button color="primary" class="!min-w-0 !px-2" (click)="openAllocationFor(request)">
                        <span autoTranslate>Abrir alocação</span>
                    </button>
                    <button
                        mat-stroked-button
                        color="warn"
                        class="!min-w-0 !px-2"
                        [disabled]="rejectingId === request.access_approval_request_id"
                        (click)="reject(request)"
                    >
                        <span autoTranslate>Rejeitar</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</mat-menu>
